const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const Slot = () => import(/* webpackChunkName: "slot" */ './view/edit.vue');

export const ROUTE_NAME_SLOT = 'Slot' as const;

export default [
    {
        path: '/app/:appId/slot',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_SLOT,
                component: Slot,
                meta: { requiresAuth: true }
            }
        ]
    }
];
